// extracted by mini-css-extract-plugin
export default {"saveBtn":"GenericForm_saveBtn__2HXo6"};